module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_7.45faa8bf.jpg";